<script>
import { PhxIcon, PhxLightbox } from '@phx-styleguides/jlc';
import LightBoxMixin from '@phoenix/mixins/components/product/LightBoxMixin';

export default {
  components: {
    PhxLightbox,
    PhxIcon,
  },
  mixins: [LightBoxMixin],

  props: {
    sliderId: {
      type: String,
      default: '',
    },
    optionsSlider: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      slider: null,
    };
  },

  mounted() {
    if (this.sliderId) {
      this.createSlider();
    }
  },

  methods: {
    createSlider() {
      const sliderElement = document.getElementById(this.sliderId);
      if (sliderElement) {
        this.slider = Toolkit.slider(sliderElement, this.optionsSlider);
      }
    },

    handleChange(index) {
      if (this.slider) {
        this.slider.slideTo(index);
      }
    },
  },
};
</script>

<template>
  <phx-lightbox
    :id="lightBoxId"
    teleport-target="teleport-target-panels"
    :items="items"
    :loop="loop"
    :i18n="i18n"
    @change="handleChange"
  >
    <template #closeButton="{ onClick, className }">
      <button
        type="button"
        :class="['btn btn--default btn--md btn--icon-only btn--icon btn--negative', className]"
        @click="onClick"
      >
        <span class="btn__icon">
          <phx-icon icon="cross-16" class="icon--" />
        </span>
      </button>
    </template>
  </phx-lightbox>
</template>
